import React from 'react';

import {SelectBaseRTK} from 'app/components/general/SelectBase/SelectBaseRTK';

import {FormItem} from './BaseFormField';

import type {FormItemProps} from './BaseFormField';
import type {ActionMeta} from 'app/components/general/SweetReactSelect';
import type {UseListQueryType} from 'app/store/sweet-api/api-query';

interface Props<T> extends Omit<FormItemProps, 'children' | 'onChange'> {
  placeholder: string;
  disabled?: boolean;
  onChange: (value: T | null, meta: ActionMeta<T>) => Promise<unknown>;
  useDataHook: UseListQueryType<{page: string}, T>;
  formatOptionLabel: (option: T) => string;
  selected: T;
  isClearable: boolean;
}

export function SweetSelectField<T extends {id: string}>({
  onChange,
  disabled,
  useDataHook,
  placeholder,
  selected,
  formatOptionLabel,
  isClearable,
  ...props
}: Props<T>) {
  return (
    <FormItem {...props}>
      <div className="col-xl-2 col-lg-3 col-6 p-0">
        <SelectBaseRTK
          isMulti={false}
          isClearable={isClearable}
          refetchDataOnOpen={true}
          selected={selected}
          useDataHook={useDataHook}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          selectProps={{formatOptionLabel}}
          paramsConverter={() => ({page: '1'})}
        />
      </div>
    </FormItem>
  );
}
